// Frontend-only value sets for the issues surface. See enums/shell.ts for the rationale.

import { ISSUE_LIFECYCLE_STATES, ISSUE_SEVERITIES } from "contracts/enums/core";

// The issue list's filter and sort vocabulary: the contract issue enums plus
// the "all" pass-throughs that only a dropdown needs.

export const ISSUE_STATUS_FILTERS = [
  "unresolved",
  "done",
  "resolved",
  "ignored",
  "all",
] as const;
export const ISSUE_STATUS_FILTER = {
  UNRESOLVED: "unresolved",
  DONE: "done",
  RESOLVED: "resolved",
  IGNORED: "ignored",
  ALL: "all",
} as const satisfies Record<string, IssueStatusFilter>;
export type IssueStatusFilter = (typeof ISSUE_STATUS_FILTERS)[number];

// The derived lifecycle axis as a filter: the six contract states plus an
// "all" pass-through. Separate from the analyst-status tabs above.
export const ISSUE_LIFECYCLE_FILTERS = [
  "all",
  ...ISSUE_LIFECYCLE_STATES,
] as const;
export type IssueLifecycleFilter = (typeof ISSUE_LIFECYCLE_FILTERS)[number];

// Severity as a filter: the four contract severities plus an "all"
// pass-through, ordered as the dropdown lists them.
export const ISSUE_SEVERITY_FILTERS = ["all", ...ISSUE_SEVERITIES] as const;
export type IssueSeverityFilter = (typeof ISSUE_SEVERITY_FILTERS)[number];

export const ISSUE_SORT_KEYS = ["impact", "severity", "recent"] as const;
export const ISSUE_SORT_KEY = {
  IMPACT: "impact",
  SEVERITY: "severity",
  RECENT: "recent",
} as const satisfies Record<string, IssueSortKey>;
export type IssueSortKey = (typeof ISSUE_SORT_KEYS)[number];

export const ISSUE_PRESENTATION_SIGNIFICANCES = [
  "decision_critical",
  "structural_quality",
  "supporting_hygiene",
] as const;
export const ISSUE_PRESENTATION_SIGNIFICANCE = {
  DECISION_CRITICAL: "decision_critical",
  STRUCTURAL_QUALITY: "structural_quality",
  SUPPORTING_HYGIENE: "supporting_hygiene",
} as const satisfies Record<string, IssuePresentationSignificance>;
export type IssuePresentationSignificance =
  (typeof ISSUE_PRESENTATION_SIGNIFICANCES)[number];
